export default __webpack_public_path__ + "static/media/hvac.9930f05b.jpeg";